module.exports = __webpack_public_path__ + "img/logo-zodiac.4b3ebd2d.jpeg";